import { isRegistration, type UpdateRegistrationLike } from './update-ready.js';

/** The one method this client needs; injected so the registration is testable without a browser. */
export interface ServiceWorkerContainerLike {
  register(url: string, options: { scope: string }): Promise<unknown>;
}

export async function registerServiceWorker(
  container: ServiceWorkerContainerLike | undefined,
  url: string,
  onError: (error: unknown) => void = () => undefined,
  onRegistered: (registration: UpdateRegistrationLike) => void = () => undefined,
): Promise<boolean> {
  // A browser without service workers still gets a working client; it just does not work offline.
  if (container === undefined) {
    return false;
  }

  let registration: unknown;
  try {
    registration = await container.register(url, { scope: '/' });
  } catch (error) {
    // A refused registration (private mode, blocked storage) must not take the client down with it.
    onError(error);
    return false;
  }

  if (isRegistration(registration)) {
    onRegistered(registration);
  }

  return true;
}
